import React from 'react';
import './NewsItem.scss';
import { NavLink } from 'react-router-dom';
import NewsItemTitle from './NewsItemTitle/NewsItemTitle';
import NewsItemDescription from './NewsItemDescription/NewsItemDescription';
import NewsItemBanner from './NewsItemBanner/NewsItemBanner';
import NewsItemShare from './NewsItemShare/NewsItemShare';
import { formatDate } from '../../Modules/GeneralModule/GeneralLogic';

/*
  Одна колонка чтения: заголовок, дата, кнопки «поделиться», картинка,
  текст. Внизу — ссылка на список и три следующие новости. Список новостей
  модуль и так запрашивает для себя, отдельного запроса здесь нет.
*/
const RELATED_COUNT = 3;

const NewsItem = ({ newsItemData, newsList }) => {
  const current = newsItemData?.id;
  const related = (newsList || [])
    .filter((e) => e?.id !== current)
    .slice(0, RELATED_COUNT);

  return (
    <div className='newsItem_container'>
      <div className="newsItem_block">
        <NewsItemTitle date={newsItemData?.created_at} title={newsItemData?.title} />
        <NewsItemShare title={newsItemData?.title} />
        <NewsItemBanner img={newsItemData?.image} title={newsItemData?.title} />
        <NewsItemDescription text={newsItemData?.text} />

        <NavLink className="newsItem_back" to="/news">
          <span aria-hidden="true">←</span> Все новости
        </NavLink>

        {related.length > 0 && (
          <div className="newsItem_related">
            <h2>Читайте также</h2>
            <div className="newsItemRelated_list">
              {related.map((e) => (
                <NavLink key={e.id} className="newsItemRelated_row" to={`/newsItem/${e.id}`}>
                  <span className="newsItemRelated_date">{formatDate(e.created_at)}</span>
                  <h3 className="newsItemRelated_title">{e.title}</h3>
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsItem;
